export enum LuggageCardDataType {
  Backpack = 'Backpack',
  HandLuggage = 'HandLuggage',
  Luggage = 'Luggage',
}

export interface LuggageCardRow {
  Type: LuggageCardDataType;
  Title: string;
  Description?: string;
  IsDisabled: boolean;
}
